import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import OneSwatches from 'Modules/module-oneSwatches';

var ViewQuickShop = Backbone.View.extend({

  initialize: function (settings) {
    console.log('init view-quickshop');
    var self = this;

    self.$content = self.$el;
    self.$productInfo = self.$content.find('.product-info');
    self.$productMedia = self.$content.find('.product-media');
    self.isProductPage = settings.isProductPage || false;

    self.productInfo();

    if (self.$productMedia.length > 0) {
      self.productMedia();
    }
  },

  events: {},

  productMedia: function(){
    var self = this;

    self.$productMedia.slick({
      dots: false,
      infinite: true,
      speed: 600,
      rows: 0,
      slidesToShow: 1,
      arrows: true,
      mobileFirst: true,
      lazyLoad: 'progressive'
    });
  },

  productInfo: function() {
    var self = this;

    var $form = self.$productInfo.find('form'),
      onesize = $form.hasClass('onesize'),
      pid = $form.data('product-id'),
      pdata = $form.find('[data-product-json]').length ? JSON.parse($form.find('[data-product-json]').html()) : false;

    new Shopify.OptionSelectors('productSelect-' + pid, {
      product: pdata,
      onVariantSelected: ShopifyAPI.selectCallback,
      enableHistoryState: false
    });
    OneSwatches.init({ el: self.$content, preSelect: onesize, product: pdata, isProductPage: self.isProductPage });
    
    self.ajaxCart();
    self.$content.addClass('initialized');
  },

  ajaxCart: function(){
    var self = this;
    $('.add-to-cart-form').off('submit');
    ajaxCart.init({
      formSelector: '.add-to-cart-form',
      addToCartSelector: '.add-to-cart-btn',
      cartContainer: '#CartContainer',
      cartCountSelector: '.minicart-count',
      cartCostSelector: '#CartCost',
      moneyFormat: theme.moneyFormat
    });
  },

  destroy: function() {
    var self = this;
    self.undelegateEvents();
  },
    
  isMobile: function () {
      if ( ORW.responsive == 'small') {
          return true;
      }
      return false;
  }
});

export default ViewQuickShop;